import { render, staticRenderFns } from "./BoardEmptyQnaLayout.vue?vue&type=template&id=7bc59372&scoped=true&"
import script from "./BoardEmptyQnaLayout.vue?vue&type=script&lang=js&"
export * from "./BoardEmptyQnaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc59372",
  null
  
)

export default component.exports